import Vue from "vue";
// import { resolve } from 'bluebird';

export function login(username, password) {
  return new Promise(resolve => {
    var auth = "Basic " + btoa(username + ":" + password);
    Vue.http.get("user/info.svc?session", { headers: { Authorization: auth } }).then(
        response => {
          resolve(
            Object.assign({ auth: true }, response.body)
          );
        },
        response => {
          console.log("Login error in user.api with status code=" + response.status);
          resolve({ auth: false, user: "", status: response.status, body: response.body});
        }
      );
  });
}

export function getUserInfo() {
  return new Promise(resolve => {
    Vue.http.get("user/info.svc?session").then(
        response => {
          resolve(
            Object.assign({ auth: true }, response.body)
          );
        },
        response => {
          console.log("Error geting userInfo " + response.status);
          resolve({ auth: false, user: "" });
        }
      ).catch(() => {
        resolve({ auth: false, user : ""});
      });
  });
}

export function logout() {
  var resource = this.$resource(process.env.VUE_APP_API_PATH + "/logoff.do");
  resource.get().then(
    response => {
      this.$store.state.auth = false;
      // ignore duplicate navigation errors.
      this.$router.push({ name : "dashboard" }).catch(e => {});
    },
    response => {
      console.log("Error " + response.status);
    }
  );
}
